import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminRemoveLayout.styles';
// import {
//   AdminHeader,
//   AdminFooter,
//   AdminSideSlides,
//   AdminRemoveLayoutMain,
//   KioskIdelScreen
// } from '..';

import AdminHeader from './../AdminLayout/AdminHeader';
import AdminFooter from './../AdminLayout/AdminFooter';
import AdminSideSlides from './../AdminLayout/AdminSideSlides';
import AdminRemoveLayoutMain from './AdminRemoveLayoutMain';
import KioskIdelScreen from './../../KioskLayout/KioskIdelScreen';

export class AdminRemoveLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: 'Scan the stock code to begin.',
    height: 300
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <AdminHeader myLogoheight={this.state.height} />
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminRemoveLayoutMain />
        <AdminFooter customFooterBottom="0%" />
        <KioskIdelScreen />
      </div>
    );
  }
}
export default withStyles(styles, { withTheme: true })(AdminRemoveLayout);
